import { graphql, useStaticQuery } from 'gatsby';

import { type Lucid } from '../types/types';

type DefaultPageType = 'learning_center_url' | 'contact_sales_url' | 'enterprise_url' | 'solution_hub_url';

type QueryPageResult = {
  translations?: {
    languages_code?: {
      short_code?: Lucid.I18n.LanguagesShortCode;
    };
    path?: { url?: string };
  }[];
};

const useDefaultPageUrls = (languageKey: Lucid.I18n.LanguagesShortCode) => {
  const queryResult = useStaticQuery<{ directus: Record<DefaultPageType, QueryPageResult> }>(graphql`
    query useDefaultPageUrlsQuery {
      directus {
        learning_center_url: learning_center_by_id(id: 1) {
          translations {
            languages_code {
              short_code
            }
            path {
              url
            }
          }
        }
        contact_sales_url: contact_form_by_id(id: 2) {
          translations {
            languages_code {
              short_code
            }
            path {
              url
            }
          }
        }
        enterprise_url: enterprise_2_by_id(id: 1) {
          translations {
            languages_code {
              short_code
            }
            path {
              url
            }
          }
        }
        solution_hub_url: solution_hub_by_id(id: 1) {
          translations {
            languages_code {
              short_code
            }
            path {
              url
            }
          }
        }
      }
    }
  `);

  const defaultPageUrls = (Object.keys(queryResult.directus) as DefaultPageType[]).reduce<
    Record<DefaultPageType, string | undefined>
  >(
    (obj, pageType) => {
      obj[pageType] = queryResult.directus[pageType].translations?.find(
        t => t.languages_code?.short_code === languageKey,
      )?.path?.url;

      return obj;
    },
    {} as Record<DefaultPageType, string | undefined>,
  );

  return defaultPageUrls;
};

export default useDefaultPageUrls;
